// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__Tirju","low":"divider_low__Y_MbR","medium":"divider_medium__7MWGr","high":"divider_high__csuv_"};